import React from 'react'
import Player from "@madzadev/audio-player";


import './Reproductor.scss';

const Reproductor = () => {
    const colors = `html {
        --tagsBackground: #9440f3;
        --tagsText: #ffffff;
        --tagsBackgroundHoverActive: #2cc0a0;
        --tagsTextHoverActive: #ffffff;
        --searchBackground: #18191f;
        --searchText: #ffffff;
        --searchPlaceHolder: #575a77;
        --playerBackground: #18191f;
        --titleColor: #ffffff; 
        --timeColor: #ffffff;
        --progressSlider: #9440f3;
        --progressUsed: #ffffff;
        --progressLeft: #151616;
        --volumeSlider: #9440f3;
        --volumeUsed: #ffffff;
        --volumeLeft:  #151616;
        --playlistBackground: #181f1b;
        --playlistText: #575a77;
        --playlistBackgroundHoverActive:  #18191f;
        --playlistTextHoverActive: #ffffff;
    }`;

    const tracks = [
        {
            url: "../../audios/page7-1.mp3",
            title: "01-Exercise 1 - Page 7",
            tags: ["house"],
        },
        {
            url: "../../audios/page8-2.mp3",
            title: "02-Exercise 2 - Page 8",
            tags: ["dnb"],
        },
        {
            url: "../../audios/page10-4.mp3",
            title: "03-Exercise 4 - Page 10",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page11-6.mp3",
            title: "04-Exercise 6 - Page 11",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page15-1.mp3",
            title: "05-Exercise 1 - Page 15",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page16-2.mp3",
            title: "06-Exercise 2 - Page 16",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page18-4.mp3",
            title: "07-Exercise 4 - Page 18",
            tags: ["dubstep"],
        },
        {    
            url: "../../audios/page20-8.mp3",
            title: "08-Exercise 8 - Page 20",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page22-1.mp3",
            title: "09-Exercise 1 - Page 22",
            tags: ["house"],
        },
        {
            url: "../../audios/page23-4.mp3",
            title: "10-Exercise 4 - Page 23",
            tags: ["dnb"],
        },
        {
            url: "../../audios/page27-1.mp3",
            title: "11-Exercise 1 - Page 27",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page28-2.mp3",
            title: "12-Exercise 2 - Page 28",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page30-4.mp3",
            title: "13-Exercise 4 - Page 30",
            tags: ["dubstep"],
        },
        {    
            url: "../../audios/page35-1.mp3",
            title: "14-Exercise 1 - Page 35",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page36-2.mp3",
            title: "15-Exercise 2 - Page 36",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page38-4.mp3",
            title: "16-Exercise 4 - Page 38",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page39-6.mp3",
            title: "17-Exercise 6 - Page 39",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page40-9.mp3",
            title: "18-Exercise 9 - Page 40",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page42-1.mp3",
            title: "19-Exercise 1 - Page 42",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page43-3.mp3",
            title: "20-Exercise 3 - Page 43",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page47-1.mp3",
            title: "21-Exercise 1 - Page 47",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page48-2.mp3",
            title: "22-Exercise 2 - Page 48",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page50-4.mp3",
            title: "23-Exercise 4 - Page 50",
            tags: ["dubstep"],
        },
        {    
            url: "../../audios/page51-6.mp3",
            title: "24-Exercise 6 - Page 51",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page55-1.mp3",
            title: "25-Exercise 1 - Page 55",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page56-2.mp3",
            title: "26-Exercise 2 - Page 56",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page58-4.mp3",
            title: "27-Exercise 4 - Page 58",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page60-8.mp3",
            title: "28-Exercise 8 - Page 60",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page62-1.mp3",
            title: "29-Exercise 1 - Page 62",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page63-4.mp3",
            title: "30-Exercise 4 - Page 63",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page67-1.mp3",
            title: "31-Exercise 1 - Page 67",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page68-2.mp3",
            title: "32-Exercise 2 - Page 68",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page70-4.mp3",
            title: "33-Exercise 4 - Page 70",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page75-1.mp3",
            title: "34-Exercise 1 - Page 75",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page76-2.mp3",
            title: "35-Exercise 2 - Page 76",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page78-4.mp3",
            title: "36-Exercise 4 - Page 78",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page80-8.mp3",
            title: "37-Exercise 8 - Page 80",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page82-1.mp3",
            title: "38-Exercise 1 - Page 82",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page84-5.mp3",
            title: "39-Exercise 5 - Page 84",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page87-1.mp3",
            title: "40-Exercise 1 - Page 87",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page88-2.mp3",
            title: "41-Exercise 2 - Page 88",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page90-4.mp3",
            title: "42-Exercise 4 - Page 90",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page91-6.mp3",
            title: "43-Exercise 6 - Page 91",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page95-1.mp3",
            title: "44-Exercise 1 - Page 95",
            tags: ["dubstep"],
        },
        {    
            url: "../../audios/page96-2.mp3",
            title: "45-Exercise 2 - Page 96",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page98-4.mp3",
            title: "46-Exercise 4 - Page 98",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page100-8.mp3",
            title: "47-Exercise 8 - Page 100",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page102-1.mp3",
            title: "48-Exercise 1 - Page 102",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page103-3.mp3",
            title: "49-Exercise 3 - Page 103",
            tags: ["dubstep"],
        }
    ];

    return (
        <Player 
            trackList={tracks}
            includeTags={false}
            ncludeSearch={true}
            showPlaylist={true}
            autoPlayNextTrack={true}
            customColorScheme={colors}
        />
    )
}

export default Reproductor